var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.activeLocations),function(location){return _c('div',{key:location._id,staticClass:"list-item p-0 is-clickable",on:{"click":function($event){return _vm.select(location)}}},[_c('LocationCard',{staticClass:"is-shadowless",attrs:{"location":location,"size":"small"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }